import type { MediaPlanConfigBehavior } from '../media-plan-config-registry';

// Beeswax-specific media-plan config behaviour. The finalize prompt names BW payload fields
// (campaign_mode, line_item.bidding.cpm_bid), so it lives here with the other Beeswax frontend
// pieces (preview card) rather than in the generic registry.
export const beeswaxConfigBehavior: MediaPlanConfigBehavior = {
  buildProposePrompt: s =>
    [
      'The user has finalized the configuration in the workspace card. Use exactly these values:',
      `- account_id=${s.accountId ?? ''}`,
      `- campaign_mode=${s.campaignMode}${s.campaignId ? ` (existing id ${s.campaignId})` : ''}`,
      `- line_item.type=${s.lineItemType}`,
      `- line_item.budget_type=${s.budgetType}`,
      `- line_item.bidding.strategy=${s.biddingStrategy}`,
      `- line_item.bidding.pacing=${s.pacing}`,
      `- line_item.bidding.cpm_bid=${s.cpmBid}`,
      s.geo && s.geo.length > 0 ? `- targeting.geo=${s.geo.join(', ')}` : '- targeting.geo=(none)',
      'Call createMediaPlan ONCE using these values. Default the line item name and dates from the execution line item context. Default spend_budget.lifetime to the execution line item MEDIA BUDGET (the margin-removed spend target in the context). If the media budget is not derivable, ask the user for the intended media spend.'
    ].join('\n')
};
